<template>
    <path d="M3 3L17 17" :stroke="color" stroke-width="2"></path>
    <path d="M17 3L3 17" :stroke="color" stroke-width="2"></path>
</template>

<script>
    export default {
        name: 'icon-cross-2',
        props: {
            color: {
                type: String,
                default: '#00AF41'
            }
        }

    }
</script>